export type RecordDetailItem = Readonly<{ label: string; value: string | number | null | undefined }>;

export function RecordDetails({ items, ariaLabel = "Dettaglio record" }: { items: RecordDetailItem[]; ariaLabel?: string }) {
  return (
    <dl className="standard-record-details" aria-label={ariaLabel}>
      {items.map((item) => (
        <div key={item.label}>
          <dt>{item.label}</dt>
          <dd>{item.value === null || item.value === undefined || item.value === "" ? "—" : item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
